// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.display-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}
.display-container .epr-links-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.display-container .epr-links-container .epr-link {
  font-weight: 500;
  margin: 10px 10px 10px 0;
  min-width: 450px;
  text-align: left;
  white-space: nowrap;
  width: 95%;
}
.display-container .results-container {
  display: flex;
  flex-direction: column;
  font-size: 0.9rem;
  max-height: 300px;
  min-width: 400px;
  overflow-y: auto;
  width: 100%;
}
.display-container .results-container .error {
  color: red;
}
.display-container .results-container .success {
  color: green;
}

.back-to-dashboard {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/styles/EprLinks.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AACJ;AAAI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AAER;AADQ;EACI,gBAAA;EACA,wBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;AAGZ;AAAI;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAER;AADQ;EACI,UAAA;AAGZ;AADQ;EACI,YAAA;AAGZ;;AACA;EACI,gBAAA;AAEJ","sourcesContent":[".display-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    width: 100%;\n    .epr-links-container {\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        .epr-link {\n            font-weight: 500;\n            margin: 10px 10px 10px 0;\n            min-width: 450px;\n            text-align: left;\n            white-space: nowrap;\n            width: 95%;\n        }\n    }\n    .results-container {\n        display: flex;\n        flex-direction: column;\n        font-size: 0.9rem;\n        max-height: 300px;\n        min-width: 400px;\n        overflow-y: auto;\n        width: 100%;\n        .error {\n            color: red;\n        }\n        .success {\n            color: green;\n        }\n    }\n}\n.back-to-dashboard {\n    margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
